// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1l_dc","inputDescription":"styles_inputDescription__2N8lD"};